import { doc, getDoc } from "firebase/firestore";

export const getCreatomateTemplate = async (db, raceId, trackId) => {
  const document = await getDoc(doc(db, "races", raceId, "configs", "creatomate"));
  return document.data().templates[trackId];
};
